import { RefObject, useEffect, useMemo } from "react";

import { ISelectOption } from "../../common/interfaces";
import { dispatchAssetTypesAction } from "../../store/assets/actions";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../utils/hooks/store";
import { CustomButton } from "../CustomButton";
import { FormInput } from "../FormInput";
import { FormSelect } from "../FormSelect";
import { CreateNewRowWrapper } from "../shared/CreateNewRowWrapper";
import { useTranslation } from "react-i18next";

interface IProps {
  headers: string[];
  className?: string;
  onSubmit?: () => void;
  onSelectType: (id: any) => void;
  inputRef?: RefObject<HTMLInputElement>;
  countRef?: RefObject<HTMLInputElement>;
  checkDateRef?: RefObject<HTMLInputElement>;
}

export const CreateNewAssetRow = (props: IProps) => {
  const { headers, inputRef, countRef, checkDateRef, className, onSelectType, onSubmit } = props;
  const { types } = useAppSelector((state: RootState) => state.assets);

  const { t } = useTranslation();

  useEffect(() => {
    dispatchAssetTypesAction();
  }, []);

  const options = useMemo((): ISelectOption[] => types.map((type) => ({ value: type.id, label: type.name })), [types]);

  return (
    <CreateNewRowWrapper>
      <div className={`d-flex justify-content-between flex-column flex-lg-row gap-2 w-100 ${className ?? ""}`}>
        {headers.map((header) => (
          <FormInput
            key={header}
            type="text"
            name={header}
            label={header}
            className="w-100"
            onChange={() => {}}
            inputRef={inputRef}
            placeholder={`${t("dashboard.inputEnter")} ${header}`}
          />
        ))}
        <FormSelect
          name="Type"
          label={t("dashboard.assets.headers.type")}
          className="w-100 w-lg-50"
          onChange={onSelectType}
          options={options}
        />
        <FormInput
          min="1"
          type="number"
          name="count"
          label={t("dashboard.assets.countPlaceholder")}
          className="w-25"
          defaultValue={1}
          onChange={() => {}}
          inputRef={countRef}
          placeholder={`${t("dashboard.inputEnter")} ${t("dashboard.assets.countPlaceholder")}`}
        />
        <FormInput
          type="date"
          name="checkDate"
          min={new Date().toISOString().split("T")[0]}
          label={t("dashboard.assets.headers.checkDate")}
          className="w-100 w-lg-50"
          onChange={() => {}}
          inputRef={checkDateRef}
          placeholder={`${t("dashboard.inputEnter")} ${t("dashboard.assets.headers.checkDate")}`}
        />
      </div>
      <CustomButton label="" icon="check" styleType="success" className="w-100 w-lg-25" py={2} onClick={onSubmit} />
    </CreateNewRowWrapper>
  );
};
